import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import './ConsentRequestBulkDropZone.css';
import {Modal, ModalBody, Button, Alert} from "reactstrap";
import {sharedLabelsPath} from "../../../../reducers/common/localization";
import { Utils } from '../../../../utils/utils';

const MAX_FILE_SIZE = '20 MB';

class ConsentRequestBulkDropZone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEnter: false,
            file: null,
            error: false,
            isFileFormatModalOpen: false
        };
    };

    componentWillUpdate(nextProps) {
        if (!this.props.clean && nextProps.clean) {
            this.cleanState();
        }
    }

    render() {
        return (
            <div className='bulk-drop-zone-container'>
                <div className="bulk-drop-zone-info">
                    <span>{_.get(this.props.translation, 'bulk_upload.max_file_size_message')}: {MAX_FILE_SIZE}</span>
                    <Button color="link" onClick={this.toggleModal}>{_.get(this.props.translation, 'bulk_upload.file_format_details_label')}</Button>
                </div>
                <Dropzone
                    className='bulk-drop-zone'
                    activeClassName='bulk-drop-zone-active'
                    onDrop={this.onDrop}
                    multiple={false}
                    onDragEnter={this.onDragEnter}
                    onDragLeave={this.onDragLeave}
                    onClick={this.cleanState}
                >
                    <div
                        className={'bulk-drop-zone-content-container ' + (this.state.isEnter ? 'bulk-drop-zone-content-active' : '')}>
                        <h6>{_.get(this.props.translation, 'bulk_upload.drag_and_drop_label')}</h6>
                        <h6>{_.get(this.props.translation, 'bulk_upload.or_label')}</h6>
                        <h6>{Utils.getTagsFromStringWithStyles(_.get(this.props.translation, 'bulk_upload.browse_label'))}</h6>
                    </div>
                </Dropzone>
                <div className="bulk-result-label">
                    {this.state.error ? <h6>{_.get(this.props.translation, 'bulk_upload.error_label')}</h6> : ""}
                    {this.props.error ? <Alert className="bulk-upload-error-alert"
                        color="danger">{this.props.error}</Alert> : ""}
                </div>
                {this.renderFileFormatModal()}
            </div>
        );
    }

    renderFileFormatModal = () => {
        return (
            <Modal isOpen={this.state.isFileFormatModalOpen} toggle={this.toggleModal}>
                <ModalBody>
                    <h6 className="text-center">{_.get(this.props.translation, 'bulk_upload.file_format_info_label')}</h6>
                    <span>{_.get(this.props.translation, 'bulk_file_format_details.consent_bulk_file_info_label')}</span>
                    <div className="file-format-button-group">
                        <Button className="olive-green-btn" onClick={this.toggleModal}>
                            {_.get(this.props.translation, sharedLabelsPath.okey_button)}
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        );
    };

    toggleModal = () => {
        this.setState({isFileFormatModalOpen: !this.state.isFileFormatModalOpen});
    };

    formatIsCorrect = (file) => {
        return file.name.endsWith('.txt') || file.name.endsWith('.csv');
    };

    onDragEnter = () => {
        this.setState({isEnter: true});
        this.cleanState();
    };

    onDragLeave = () => {
        this.setState({isEnter: false});
    };

    onDrop = (filesArray) => {
        this.setState({isEnter: false});

        if (filesArray.length !== 1) {
            this.setState({error: true});
            return;
        }

        let file = filesArray[0];
        if (this.formatIsCorrect(file)) {
            this.setState({file: file});
            this.props.onSubmit(file);
        } else {
            this.setState({error: true});
        }
    };

    cleanState = () => {
        this.setState({
            file: null,
            error: false
        });
    };
}

ConsentRequestBulkDropZone.propTypes = {
    translation: PropTypes.object.isRequired,
    onSubmit: PropTypes.func
};

export default ConsentRequestBulkDropZone;



// WEBPACK FOOTER //
// ./src/components/consentManagement/credentialsVerificationRequest/consentRequestBulkDropZone/ConsentRequestBulkDropZone.js